import { render, staticRenderFns } from "./CompletedTest.vue?vue&type=template&id=23351f88&"
import script from "./CompletedTest.vue?vue&type=script&lang=js&"
export * from "./CompletedTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports